import { Fragment, useState, forwardRef, useEffect } from 'react';
import Slide from '@mui/material/Slide';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Checkbox,
    FormControlLabel,
    TextField,
    Button,
    DialogActions,
    Autocomplete
} from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import axiosInstance from '../../../utility/axios-instance';
import SnackBar from '../../../components/SnackBar';
import moment from 'moment';



const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const InboundDialog = (props) => {
    const { open, handleClose, products, bins, locationCode, Id, title } = props;
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [snackBar, setSnackBar] = useState({ display: false, type: "success", message: "default message!" })
    const [stagingBins, setStagingBins] = useState([]);

    const closePopup = () => {
        setSelectedProducts([]);
        handleClose();
    }

    useEffect(() => {
        if (locationCode) {
            axiosInstance.get(`/inventory/bins?locationCode=${locationCode}&type=Staging`)
                .then(res => {
                    let bins = res?.data?.data?.bins;
                    setStagingBins(bins)
                })
                .catch(error => {
                    console.log(error);
                })
        }
    }, [locationCode])

    const handleInboundSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        if(selectedProducts?.length === 0){
            const errorMessage = 'Please select atleast one product'
            setSnackBar((prevSnackBar) => {
                return { ...prevSnackBar, display: true, message: errorMessage, type: "error" }
            });
            setLoading(false)
            return
        }
        const data = selectedProducts
        await axiosInstance.post(`/purchaseOrders/inboundPoLineItems/${Id}`, data)
            .then(res => {
                const successMessage = 'Inbound Successfully'
                setSnackBar((prevSnackBar) => {
                    return { ...prevSnackBar, display: true, message: successMessage, type: "success" }
                });
                setLoading(false)
                closePopup();
            })
            .catch(error => {
                const errorMessage = error?.response?.data?.message
                setSnackBar((prevSnackBar) => {
                    return { ...prevSnackBar, display: true, message: errorMessage, type: "error" }
                });
                setLoading(false)
            })
        setLoading(false);
    }

    const handleCheckboxChange = (product, checked) => {
        if (checked) {
            // If the checkbox is checked, add the product to the selectedProducts array.
            setSelectedProducts((prevSelected) => [
                ...prevSelected,
                {
                    skuCode: product?.sku,
                    locationCode: locationCode,
                    binCode: stagingBins.find((bin) => bin?.default === true)?.code || null,
                    lineItemId: product.lineItemId,
                    quantity: product.openQty,
                },
            ]);
        } else {
            // If the checkbox is unchecked, remove the product from the selectedProducts array.
            setSelectedProducts((prevSelected) =>
                prevSelected.filter((item) => item?.lineItemId !== product?.lineItemId)
            );
        }
    };

    const handleQuantityChange = (product, e) => {
        const newQuantity = parseInt(e.target.value);
        const productId = product?.lineItemId;

        if (newQuantity === 0) {
            // If the quantity is 0, remove the product from the selectedProducts array.
            setSelectedProducts((prevSelected) =>
                prevSelected.filter((item) => item?.lineItemId !== productId)
            );
            return;
        }

        if (newQuantity > product?.openQty) {
            // If the quantity is greater than the available quantity, set the quantity to the available quantity.
            alert(`The maximum quantity available for ${product?.sku} is ${product?.openQty}.`);
            return
        }


        setSelectedProducts((prevSelected) =>
            prevSelected?.map((item) =>
                item?.lineItemId === productId
                    ? { ...item, quantity: newQuantity }
                    : item
            )
        );
    };

    const handleBinChange = (product, newValue) => {
        const productId = product?.lineItemId;

        if (newValue === null) {
            setSelectedProducts((prevSelected) =>
                prevSelected.filter((item) => item?.lineItemId !== productId)
            );
            return;
        }


        setSelectedProducts((prevSelected) =>
            prevSelected?.map((item) =>
                item?.lineItemId === productId
                    ? { ...item, binCode: newValue }
                    : item
            )
        );
    };

    
    const handleSelectAll = (e) => {
        const selectedProductsArray = products
            ?.filter((prod) => prod.openQty > 0)
            ?.map((product) => ({
                skuCode: product?.sku,
                locationCode: locationCode,
                binCode: stagingBins.find((bin) => bin?.default === true)?.code || null,
                lineItemId: product.lineItemId,
                quantity: product.openQty,
            })) || [];
        // If the checkbox is checked, set all selected products, otherwise set to an empty array
        setSelectedProducts(e.target.checked ? selectedProductsArray : []);
    };

    const isChecked = selectedProducts?.length === products?.filter((prod) => prod.openQty > 0)?.length;
    const isIndeterminate = selectedProducts.length > 0 && selectedProducts.length < products?.filter((prod) => prod.openQty > 0)?.length;

    return (
        <Fragment>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
            >
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <div style={{ margin: '8px 0px' }} >
                        <div style={{display:'flex', marginLeft:'9px' }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isChecked}
                                        indeterminate={isIndeterminate}
                                        onChange={handleSelectAll}
                                        inputProps={{ 'aria-label': 'Select all products' }}
                                        style={{padding:'0px'}}
                                        sx={{"& .MuiCheckbox-root": {padding: '0px'}, "& .MuiButtonBase-root": {padding:'0px'}}}
                                    />
                                }
                            />
                            <p style={{ fontWeight: 600 }}>Products</p>
                        </div>
                        {products?.length && products?.filter((prod) => prod.openQty > 0)?.map((product) => (
                            <div
                                key={product?.lineItemId}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    margin: '15px 0px',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={selectedProducts.some((item) => item?.lineItemId === product?.lineItemId)}
                                            onChange={(e) => handleCheckboxChange(product, e.target.checked)}
                                        />
                                    }
                                    label={
                                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                            <img
                                                src={product?.mainImageUrl ? product?.mainImageUrl : 'https://depo24-images-shopify.s3.ap-south-1.amazonaws.com/Assets/Image+Coming+Soon.png'}
                                                alt={product?.productTitle}
                                                width="50"
                                                height="50"
                                                style={{ marginRight: '10px', borderRadius: '5px', border: '0.5px solid gray' }}
                                            />
                                            <div>
                                                <p style={{ fontWeight: 600 }}>{product.sku}</p>
                                                <p style={{ fontSize: '12px' }}>Quantity: {product?.quantity}</p>
                                                <p style={{ fontSize: '12px' }}>Open: {product?.openQty}</p>
                                                <p style={{ fontSize: '12px' }}>Inbound: {product?.receivedQty}</p>
                                                {product?.estimate_date  ? <p style={{ fontSize: '12px' }}>Estimate Date: {
                                                    moment(product?.estimate_date ).format('MMM DD, YYYY h:mm:ss A')
                                                }</p> : ""}
                                            </div>
                                        </div>
                                    }
                                />
                                {selectedProducts.some(
                                    (item) => item?.lineItemId === product?.lineItemId
                                ) && (
                                        <div style={{ display: 'flex', gap: '5px', justifyContent: 'end' }}>
                                            <Autocomplete
                                                size='small'
                                                disabled={locationCode === null ? true : false}
                                                id="binId"
                                                required
                                                options={bins}
                                                style={{ width: "50%" }}
                                                onChange={(e, newValue) => {
                                                    handleBinChange(product, newValue);
                                                }}
                                                value={
                                                    selectedProducts.find(
                                                        (item) => item?.lineItemId === product?.lineItemId
                                                    ).binCode
                                                }
                                                renderInput={(params) => <TextField required {...params} label="Bin" />}
                                            />
                                            <TextField
                                                label="Quantity"
                                                type="number"
                                                size='small'
                                                value={
                                                    selectedProducts.find(
                                                        (item) => item?.lineItemId === product?.lineItemId
                                                    ).quantity
                                                }
                                                onChange={(e) => {
                                                    handleQuantityChange(product, e);
                                                }}
                                                style={{ marginLeft: '10px' }}
                                            />
                                        </div>
                                    )}
                            </div>
                        ))}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button 
                        type="submit" 
                        id='moveInventory' 
                        variant="contained" 
                        color="primary" 
                        onClick={handleInboundSubmit}
                        disabled={selectedProducts?.length === 0 ? true : false}
                    >Inbound</Button>
                    <Button onClick={closePopup}>Close</Button>
                </DialogActions>
            </Dialog>
            <SnackBar snackBar={snackBar} setSnackBar={setSnackBar} />
        </Fragment>
    )
}

export default InboundDialog;